<template>
    <router-view />
</template>

<script>
export default {
    created() {
        let isUpdate = false;
        if (this.$route.params.id) isUpdate = true;
        this.permissao = this.hasPermissionAccess('vendas', 'produtos', 'ven-produto');

        if ((!isUpdate && !this.permissao.create) || (isUpdate && !this.permissao.read)) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'produto' },
            });
        }
    },
};
</script>
